import React, { useContext, useEffect, useState } from "react";
import { ContextConvenio } from "./ListadoClientesGestionarScreen";
import { useHistory, useLocation } from "react-router-dom";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../../components/LoaderScreen";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ListIcon from "@mui/icons-material/List";
import request from "../../../../Helpers/API";
import Swal from "sweetalert2";
import JoinInnerIcon from "@mui/icons-material/JoinInner";
import { TextField } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HowToRegIcon from "@mui/icons-material/HowToReg";

export const RegistrarCliente = () => {
  const { state } = useLocation();
  const history = useHistory();
  const [clientes, setClientes] = useState([]);
  const [registro, setRegistro] = useState({
    idcliente: state.idcliente,
    razonsocial: state.razonsocial,
    rfc: "",
  });
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [registrar, setRegistrar] = useState(false);
  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`CPPredictivoClientes/Listado?idcliente=${state.idcliente}`)
      .then((result) => {
        setClientes(result);
        setRegistrar(result.length > 0 ? false : true);
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
      });
  }, []);

  const onConbinar = (idcliente) => {
    setLoader({ ...loader, mostrar: true });
    const post = {
      idcliente,
      idequip: state.idcliente,
    };
    request
      .post("RegistroClientes/Combinar", post)
      .then(async () => {
        setLoader({ ...loader, mostrar: false });
        await Swal.fire("CONVENIO PAGO", "DATOS REGISTRADOS", "info");
        history.push("/Creditoycobranza/ListadoConvenios", {
          idcliente,
          razonsocial: state.razonsocial,
        });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CONVENIO PAGO", JSON.stringify(error), "error");
      });
  };
  const capitalizeWords = (str) => {
    return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
  }; 
  return (
    <PlantillaScreen
      titulo={"REGISTRAR CLIENTE " + state.razonsocial + " EN HUMAYA DIGITAL"}
      className={"analisis-solicitud-credito-plantilla"}
      className_main={1}
    >
      <LoaderScreen loader={loader} />
      <div className="cp-combina-clientes">
        <div className="cp-combinar-clientes-header">
          {registrar === false && (
            <div onClick={() => setRegistrar(true)}>
              <AddCircleOutlineIcon />
              Registrar
            </div>
          )}
          {clientes.length > 0 && registrar === true && (
            <div onClick={() => setRegistrar(false)}>
              <ListIcon />
              Listado
            </div>
          )}
        </div>
        <div className="cp-combinar-clientes-container">
          {registrar === true ? (
            <div className="cp-combinar-clientes-container-registro">
              <TextField
                label="Razón Social"
                value={registro.razonsocial}
                onChange={({ target }) =>
                  setRegistro({ ...registro, razonsocial: target.value })
                }
              />
              <TextField
                label="RFC"
                value={registro.rfc}
                onChange={({ target }) =>
                  setRegistro({ ...registro, rfc: target.value })
                }
              />
              <div className="cp-combinar-clientes-container-registro-guardar">
                <HowToRegIcon /> Registrar
              </div>
            </div>
          ) : (
            <div className="cp-combinar-clientes-container-table scroll-4">
              <table cellPadding={0} cellSpacing={0}>
                <thead>
                  <tr>
                    <th colSpan={3}>Registros Encontrados</th>
                  </tr>
                </thead>
                <tbody>
                  {clientes.map((item) => (
                    <tr>
                      <td>{item.idcliente}</td>
                      <td>{capitalizeWords(item.razonsocial)}</td>
                      <td>
                        <div onClick={() => onConbinar(item.idcliente)}>
                          <JoinInnerIcon />
                          Combinar
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
        <div className="cp-combinar-clientes-footer">
          <div
            className="listado-convenios-cliente-footer-back"
            onClick={() =>
              history.push("/Creditoycobranza/GestionClientes")
            }
          >
            <ArrowBackIcon /> Regresar
          </div>
        </div>
      </div>
    </PlantillaScreen>
  );
};
